import React from "react";
import experience from "data/experience.js";
import { SkillsContainer } from "styles/about";

export const ExperienceComponent = () => {
  return (
    <div>
      <h1 className="stack-title">Experience</h1>
      {experience.map((exp) => (
        <div className="experience-card" key={exp.id}>
          <div className="experience-header">
            <h2>{exp.title}</h2>
            <p>{exp.period}</p>
          </div>
          <h3>{exp.company}</h3>
          <ul className="duties-ul">
            {exp.duties.map((duty, index) => (
              <li className="dutie-li" key={index}>
                {duty}
              </li>
            ))}
          </ul>
          <ul className="tech-stack-ul">
            {exp.stack.map((tech, index) => (
              <li className="tech-skill" key={index}>
                {tech}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};
